import { async } from "q";
import apis from "../../../../api";
import { errorTypes } from "../../../../utils/errorTypes";
import loaders from "../../actionCreators/loadersActionCreator";
import { setErrorHandler } from "../errorActionHandler";
import { downloadFile } from "../../../../utils/downloadFile";
import moment from "moment";

export const getPasswordExpiryPeriodActionHandler = () => async (dispatch) => {
  dispatch(loaders.admin.organizationSettings.getPasswordExpiryLoader(true));
  const tenantName = localStorage.getItem("tenantName");
  return await apis.admin.organizationSettings
    .getPasswordExpiryPeriod(tenantName)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(
        loaders.admin.organizationSettings.getPasswordExpiryLoader(false)
      );
    });
};
export const setPasswordExpiryPeriodActionHandler =
  (passwordExpirationPeriod) => async (dispatch) => {
    dispatch(loaders.admin.organizationSettings.setPasswordExpiryLoader(true));
    const tenantName = localStorage.getItem("tenantName");
    return await apis.admin.organizationSettings
      .setPasswordExpiryPeriod(tenantName, passwordExpirationPeriod)
      .then((response) => {
        dispatch(setErrorHandler(errorTypes.SUCCESS, "Expiry Day Updated"));
      })
      .catch((err) => {
        dispatch(
          setErrorHandler(errorTypes.FAIL, err?.response?.data?.Message)
        );
        console.log(err);
      })
      .finally(() => {
        dispatch(
          loaders.admin.organizationSettings.setPasswordExpiryLoader(false)
        );
      });
  };

export const getUserEmailDetailsActionHandler = () => async (dispatch) => {
  dispatch(loaders.admin.organizationSettings.getUserEmailDetailsLoader(true));
  return await apis.admin.organizationSettings
    .getUserEmailDetails()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(
        loaders.admin.organizationSettings.getUserEmailDetailsLoader(false)
      );
    });
};

export const addUserEmailDetailsActionHandler = (data) => async (dispatch) => {
  let updatedData = data.map((email, index) => {
    return { ...email, id: index + 1 };
  });
  dispatch(loaders.admin.organizationSettings.addUserEmailDetailsLoader(true));
  return await apis.admin.organizationSettings
    .addUserEmailDetails(updatedData)
    .then((response) => {
      if (response.data) {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            "Email IDs are updated successfully"
          )
        );
      }
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(
        loaders.admin.organizationSettings.addUserEmailDetailsLoader(false)
      );
    });
};

export const isDomainNameExistsActionHandler = (domainName) => async () => {
  return await apis.admin.organizationSettings
    .IsDomainNameExists(domainName)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const addDomainNameActionHandler = (name, id) => async (dispatch) => {
  let data = { Name: name, id: id };
  return await apis.admin.organizationSettings
    .addDomainName(data)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDomainNamesActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setDomainNameData,
    setTempDomainNameData,
    setTotalRows
  ) =>
  async (dispatch) => {
    return await apis.admin.organizationSettings
      .getDomainNames()
      .then((response) => {
        setDomainNameData((prevStateData) => [
          ...prevStateData,
          ...response?.data,
        ]);
        setTempDomainNameData((prevStateData) => [
          ...prevStateData,
          ...response?.data,
        ]);
        setTotalRows(response?.data?.length);
        return response?.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const deleteDomainNameActionHandler = (id) => async () => {
  return await apis.admin.organizationSettings
    .deleteDomainName(id)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateDomainNameActionHandler =
  (domainName, domainId) => async () => {
    let data = { Name: domainName, id: domainId };
    return await apis.admin.organizationSettings
      .updateDomainName(data)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const latestImportStatusActionHandler =
  (setSyncAzureDirectoryLoader) => async () => {
    setSyncAzureDirectoryLoader(true);
    apis.admin.organizationSettings
      .latestImportStatus()
      .then((response) => {
        if (response.status === 200) {
          setSyncAzureDirectoryLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getLocationListCSVActionHandler = () => async (dispatch) => {
  return await apis.admin.organizationSettings
    .getLocationListCSV()
    .then((response) => {
      const fileName = `ExportAllLocations_${moment().format("DMMMYYYY_hhmmss")}`;
      downloadFile(response.data, fileName);
      return response.data;
    })
    .catch((err) => {
      console.log(err);
      dispatch(
        setErrorHandler(errorTypes.FAIL, "Failed to download locations")
      );
    });
};

export const getUserDepartmentListCSVActionHandler = () => async (dispatch) => {
  return await apis.admin.organizationSettings
    .getUserDepartmentListCSV()
    .then((response) => {
      const fileName = `ExportAllUserDepartments_${moment().format("DMMMYYYY_hhmmss")}`;
      downloadFile(response.data, fileName);
      return response.data;
    })
    .catch((err) => {
      console.log(err);
      dispatch(
        setErrorHandler(errorTypes.FAIL, "Failed to download user departments")
      );
    });
};
